import Vue from 'vue';
import {
  chip, extraChips, entityIcon, tooltip,
} from '@/modules/list/config/utils';
import { i18n } from '@/plugins/vue-i18n';

export default function (entity, entityType) {
  return {
    id: entity.id,
    title: entity.description || entity.title || entity.name,
    icon: {
      name: entityIcon(entityType),
    },
    editor: 'entity',
    type: entityType,
    url: null,
    chips: [
      tooltip(chip(entity.creationDate ? Vue.filter('formatDate')(entity.creationDate) : null), i18n.t('message.metadata.creationDate')),
      tooltip(chip(entity.modificationDate ? Vue.filter('formatDate')(entity.creationDate) : null), i18n.t('message.metadata.modificationDate')),
      ...extraChips(entity.badges),
    ].filter(c => !!c.value),
  };
}
